import React, { useState, useEffect } from 'react';
import { FaCalendarCheck, FaCheckCircle, FaClock, FaTimesCircle, FaCheckDouble } from 'react-icons/fa';

const AdmHotelBookingStats = ({ bookings = [] }) => {
  const [stats, setStats] = useState({
    total: 0, confirmed: 0, pending: 0, cancelled: 0, completed: 0,
  });

  useEffect(() => {
    setStats({
      total:     bookings.length,
      confirmed: bookings.filter(b => b.booking_status === 'confirmed').length,
      pending:   bookings.filter(b => b.booking_status === 'pending').length,
      cancelled: bookings.filter(b => b.booking_status === 'cancelled').length,
      completed: bookings.filter(b => b.booking_status === 'completed').length,
    });
  }, [bookings]);

  const cards = [
    { title: 'Total Bookings', value: stats.total,     icon: FaCalendarCheck, color: 'blue'  },
    { title: 'Confirmed',      value: stats.confirmed, icon: FaCheckCircle,    color: 'green' },
    { title: 'Pending',        value: stats.pending,   icon: FaClock,          color: 'amber' },
    { title: 'Cancelled',      value: stats.cancelled, icon: FaTimesCircle,    color: 'red'   },
    { title: 'Completed',      value: stats.completed, icon: FaCheckDouble,    color: 'teal'  },
  ];

  return (
    <div className="adm-pkg-stats-grid">
      {cards.map((card, i) => {
        const Icon = card.icon;
        return (
          <div key={i} className={`adm-pkg-stat-card adm-pkg-stat-${card.color}`}>
            <div className="adm-pkg-stat-icon">
              <Icon />
            </div>
            <div className="adm-pkg-stat-content">
              <div className="adm-pkg-stat-value">{card.value}</div>
              <div className="adm-pkg-stat-title">{card.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdmHotelBookingStats;